// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3QQtH","header":"ReportDetails_header__2vuWE","title":"ReportDetails_title__3rpLR","left":"ReportDetails_left__3GjVV"};